export default {
  title: 'Seleção de expediente de financiamento',
  search: 'Buscar acordos',
  expedient: 'Expediente',
  description: 'Acordo',
  amount: 'Adiantamento disponível'
}